<template>
  <div class="tabs" >
        <el-tabs v-model="activeName">
            <!-- <el-tab-pane label="审核文档" name="check"></el-tab-pane>
            <el-tab-pane label="归档文档" name="cate"></el-tab-pane> -->

            <div class="panelInstance">
                <div class="panelInstance-left">
                    <roleTree @node-click="nodeClick" />
                </div>
                <div class="panelInstance-right">
                    <perm-document :node="node" :type="tabType"></perm-document>
                </div>
            </div>
            
        </el-tabs>
        
    </div>
</template>

<script>
import roleTree from './roleTree.vue'
import permDocument from './permDocument.vue'
export default {
    components: {
        roleTree,
        permDocument
    },
    computed: {
        tabType() {
            if (this.activeName === 'check') return '1'
            return '2'
        }
    },
    data: () => {
        return {
            activeName: "check",
            node: null
        }
    },
    methods: {
        nodeClick(data) {
            this.node = data
        }
    }
}
</script>

<style lang="scss" scoped>
.tabs {
    box-sizing: border-box;
    padding: 10px;
    height: 100%;

    /deep/ .el-tabs {
        display: flex;
        height: 100%;
        flex-flow: column nowrap;
        .el-tabs__header {
            margin: 0 0 0;
            * {
                color: gray!important;
                font-size: 15px !important;
                font-weight: 500!important;
            }
        }
        .el-tabs__content {
            min-height: 0;
            flex-grow: 1;
            overflow: hidden auto;
        }
    }
    .panelInstance {
        $left_width: 300px;
        height: 100%;
        display: flex;
         &-left {
            width: $left_width;
            box-sizing: border-box;
            padding: 10px 5px;
            border-right: 1px solid #f4f5fa;
        }
        &-right {
            width: calc(100% - #{$left_width});
        }
    }
}
</style>